import * as z from 'zod'

export const Level = z.enum(['debug', 'info', 'inspect', 'warn', 'error'])
export type Level = z.infer<typeof Level>
